/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scopesPermissionsList.vue?vue&type=template&id=04ed9e7c"
import script from "./scopesPermissionsList.vue?vue&type=script&lang=js"
export * from "./scopesPermissionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports